import { Component, input } from '@angular/core';
import { EMBEDDINGS_GENERATION_STATUS } from 'src/app/contract-management/models/contract-management.model';
import { THREAD_AGENT_SERVICE } from 'src/app/features/general-agent/tokens/thread-agent.token';
import { THREAD_AGENT_CONFIG, COMPARE_CHAT_THREAD_CONFIG } from 'src/app/features/general-agent/tokens/thread-agent-config.token';
import { ChatTabShellComponent } from 'src/app/features/general-agent/components/chat-tab-shell/chat-tab-shell.component';
import { ChatService } from '../../services/chat.service';
import { CHAT_TYPE, THREAD_TYPE } from '../../models/chat.model';

@Component({
    selector: 'app-compare-chat-tab',
    standalone: true,
    imports: [ChatTabShellComponent],
    providers: [
        { provide: CHAT_TYPE, useValue: THREAD_TYPE.COMPARE_CHAT },
        ChatService,
        { provide: THREAD_AGENT_SERVICE, useExisting: ChatService },
        { provide: THREAD_AGENT_CONFIG, useValue: COMPARE_CHAT_THREAD_CONFIG },
    ],
    templateUrl: './compare-chat-tab.component.html',
})
export class CompareChatTabComponent {
    comparisonId = input.required<string>();
    contractId = input.required<string>();
    compareDocuments = input<{ _id: string; name: string }[]>([]);
    kpiDocuments = input<{ _id: string; name: string }[]>([]);
    documentTypeId = input<string>('');
    projectId = input<string>('');
    embeddingsStatus = input<EMBEDDINGS_GENERATION_STATUS | null>(EMBEDDINGS_GENERATION_STATUS.COMPLETED);
}
